import { FC, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import CadreDesoummissions from "components/students/Submissions/Cadre2";
import UsersListView from "./userList";
import { GetUsersOutput } from "server/StartupAdmins CRUD/OutputsTypes";
import { getUsers } from "server/StartupAdmins CRUD/Requests";
import { ApiResponse } from "server";
import CircularProgress from "@mui/material/CircularProgress";
import Alert from "@mui/material/Alert";
import { Box } from "@mui/material";
import { userRoleDisplay } from "components/common/utils";

interface UsersManagementProps {
  gotoExcelCreationForm: () => void;
  gotoManualCreationForm: () => void;
  handleChange: (value: string) => void;
  values: any;
}

export const UsersManagementHome: FC<UsersManagementProps> = ({
  gotoExcelCreationForm,
  gotoManualCreationForm,
  handleChange,
}) => {
  const [users, setUsers] = useState<GetUsersOutput[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const response: ApiResponse<GetUsersOutput[]> = await getUsers();
        if (response.status === 200 && Array.isArray(response.body)) {
          setError(null);
          setUsers(
            response.body
              .sort(
                (a: GetUsersOutput, b: GetUsersOutput) =>
                  new Date(b.createdAt).getTime() -
                  new Date(a.createdAt).getTime(),
              )
              .slice(0, 5),
          );
        } else {
          setError("Erreur lors de la récupération des utilisateurs.");
        }
      } catch (err) {
        setError("Une erreur s'est produite lors de la connexion au serveur.");
      } finally {
        setLoading(false);
      }
    };

    fetchUsers();
  }, []);

  return (
    <div className="flex flex-col items-start justify-start gap-8 p-6">
      <h1 className="text-3xl font-bold text-gray-800">
        Ajouter un nouvel utilisateur
      </h1>

      <div className="w-full overflow-x-auto">
        <div className="flex flex-row p-4 space-x-4 md:space-x-10 justify-start min-w-max">
          <Link to="" onClick={gotoExcelCreationForm} className="flex-shrink-0">
            <CadreDesoummissions
              couleur="bg-[#5B7582]"
              titre="Fichier Excel"
              sousTitre="Soumettre un fichier excel"
            />
          </Link>
          <Link
            to=""
            onClick={gotoManualCreationForm}
            className="flex-shrink-0"
          >
            <CadreDesoummissions
              couleur="bg-[#7F544E]"
              titre="Manuellement"
              sousTitre="Créer manuellement par formulaire"
            />
          </Link>
        </div>
      </div>

      <div className="w-full">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-semibold text-gray-700">
            Récemment ajoutés
          </h2>
        </div>

        {loading && (
          <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
            <CircularProgress />
          </Box>
        )}

        {error && (
          <Box sx={{ mt: 4 }}>
            <Alert severity="error">{error}</Alert>
          </Box>
        )}

        {!loading && !error && users && (
          <>
            <div className="space-y-4">
              {users.map((user, index) => (
                <div
                  key={user._id}
                  className="flex justify-between items-center p-4 bg-white rounded-lg shadow-sm"
                >
                  <div>
                    <span className="text-gray-500 mr-2">{index + 1}.</span>
                    <span className="font-medium">
                      {user.firstname} {user.lastname}
                    </span>
                    <p className="text-gray-500 text-sm mt-1">
                      {userRoleDisplay(user.userRole)}{" "}
                      {user.schoolName ? `- ${user.schoolName}` : ""}
                      {user.userRole === "teacher"
                        ? user.availability.available
                          ? " - Disponible"
                          : " - Non disponible"
                        : ""}
                    </p>
                  </div>
                </div>
              ))}
            </div>

            <Link
              to="/users/list"
              className="text-[#E3B505] mt-4 text-sm hover:underline block"
            >
              Consulter plus
            </Link>
          </>
        )}
      </div>
    </div>
  );
};

export default UsersManagementHome;
